<template>
  <div id="toast-container" class="absolute inset-x-0 z-20">
    <div class="flex justify-center">
      <transition
        enter-active-class="transition duration-200 ease-out transform"
        enter-from-class="-translate-y-2 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <Toast v-if="isEnabled && currentToast" :toast="currentToast" @close="remove" />
      </transition>
    </div>
  </div>
</template>

<script setup>
import { useToastStore } from '@/stores/toast';
import Toast from '@/components/toast/Toast';

const TOAST_CLOSE_TIMEOUT = 8000;

const toastStore = useToastStore();

const maxDeferTries = ref(4);
const isEnabled = ref(false);
const timeout = ref(null);

const currentToast = computed(() => toastStore.currentToast);

watch(currentToast, (current) => {
  if (isEnabled.value && current !== false) {
    removeAfterTimeout();
  }
});

onMounted(() => {
  // check if one trust script is installed, if not the case, skip defer part
  const script = document.querySelector('[data-hid=Ot-Sdk]');
  if (script) {
    deferToastsAfterConsent();
  } else {
    enableToasts();
  }
});

/**
 * This function detects if a consent screen is shown to the user.
 *
 * If the consent screen is shown, the displaying of the toasts is deferred to
 * after the event when the user interacted with the consent.
 *
 * If no consent is shown, the toasts will enable by default
 *
 * To detect the consent Modal and the OneTrust object, we use a timeout with
 * 4 attempts to check for existence. If nothing is found we default to showing
 * the toasts.
 */
function deferToastsAfterConsent() {
  setTimeout(() => {
    const consentModal = document.querySelector('#onetrust-banner-sdk');
    const isVisible = consentModal && consentModal.style.display === '';

    if (isVisible && window.OneTrust) {
      window.OneTrust.OnConsentChanged(() => {
        enableToasts();
      });
    } else if (maxDeferTries.value > 0) {
      maxDeferTries.value--;
      deferToastsAfterConsent();
    } else {
      enableToasts();
    }
  }, 600);
}

function enableToasts() {
  setTimeout(() => {
    isEnabled.value = true;

    if (currentToast.value && !timeout.value) {
      removeAfterTimeout();
    }
  }, 300);
}

function removeAfterTimeout() {
  timeout.value = setTimeout(() => {
    remove();
  }, TOAST_CLOSE_TIMEOUT);
}

function remove() {
  if (timeout.value) {
    clearTimeout(timeout.value);
    timeout.value = null;
  }

  toastStore.shift();
}
</script>
